import Text from "@/components/ui/text";
import HighlightedText from "@/components/controls/HighlightedText";
import { useSearchHighlight } from "@/contexts/SearchHighlightContext";

const TextField: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { searchQuery, isSearchActive } = useSearchHighlight();
  const textContent =
    typeof children === "string" ? children : String(children);

  return (
    <Text variant="bodySecondary" className="max-w-[27rem]">
      {isSearchActive && typeof children === "string" ? (
        <HighlightedText text={textContent} query={searchQuery} />
      ) : (
        children
      )}
    </Text>
  );
};

export default TextField;
